import { yupResolver } from "@hookform/resolvers/yup";
import LoadingFormNormal from "components/shared-components/LoadingFormNormal";
import MessageFormValidate from "components/shared-components/MessageFormValidate";
import { formValidate } from "helpers/form_helper";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Col,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import {
  listBusinessUnit,
  detailBusinessUnit,
  resetDetailBusinessUnit,
  resetUpdateBusinessUnit,
  updateBusinessUnit,
  createBusinessUnit,
  resetListBusinessUnit,
} from "store/actions";
import * as yup from "yup";
import { emailPrefix, userModeList, userRecordStatus } from "./utils";

const DetailUser = props => {
  const {
    isOpenModal,
    dataDetail,
    toggleModal,
    mode,
    employeeList,
    userRoleList,
    userBusinessUnit,
  } = props;
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["businessUnit"]);
  const { addToast } = useToasts();

  const userManagement = useSelector(state => state.BusinessUnit);
  const {
    loadingDetail,
    errorDetail,
    detail: VATDetail,
    create: userCreate,
    loadingUpdate,
    errorUpdate,
    errorCreate,
    update: userUpdate,
  } = userManagement;

  const [isDetail, setIsDetail] = useState(false); // Prevent To Set Data Again After Success Detail
  const initControlFields = {
    display: {
      mst: false,
      dchi: false,
      ten: false,
      btn_save: false,
    },
  };

  const [controlFields, setControlFields] = useState(initControlFields);
  const history = useHistory();
  const schema = yup.object().shape({
    mst: yup.string(),
    dchi: yup.string(),
    ten: yup.string(),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      mst: "",
      dchi: "",
      ten: "",
    },
  });
  useEffect(() => {
    if (errorCreate) {
      if (errorCreate.code && errorCreate.code === 422) {
        addToast(
          "Đơn vị kinh doanh đã bị trùng, vui lòng thử lại đơn vị khác",
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        dispatch(resetUpdateBusinessUnit());
      }
    }
  }, [errorCreate]);
  useEffect(() => {
    if (!isOpenModal) {
      dispatch(resetDetailBusinessUnit());
      setIsDetail(false);
      setControlFields(initControlFields);
    }
  }, [dispatch, isOpenModal]);

  // Action Detail
  useEffect(() => {
    if (isOpenModal) {
      if (dataDetail && dataDetail.userId && !isDetail) {
        dispatch(detailBusinessUnit(dataDetail.userId));
      }
    }
  }, [dataDetail, dispatch, isDetail, isOpenModal]);

  // Set Data Detail
  useEffect(() => {
    if (isOpenModal) {
      if (VATDetail && VATDetail.success && !isDetail) {
        let username = "";
        const defaultValues = {
          user_profile_id: undefined,
          user_role: [],
        };
        reset({});
        const dataReset = {};

        dataReset["mst"] = VATDetail.mst;
        dataReset["dchi"] = VATDetail.dchi;
        dataReset["ten"] = VATDetail.ten;
        dataReset["sdthoai"] = VATDetail.sdthoai;
        dataReset["dctdtu"] = VATDetail.dctdtu;
        (dataReset["send_mail"] = VATDetail.send_mail),
          (dataReset["stknhang"] = VATDetail.stknhang);
        dataReset["tnhang"] = VATDetail.tnhang;
        dataReset["fax"] = VATDetail.fax;
        dataReset["website"] = VATDetail.website;

        switch (mode) {
          case userModeList.VIEW_USER_DETAIL:
            reset({ ...defaultValues, ...dataReset });

            if (VATDetail) {
              setValue("mst", VATDetail.mst);
              setValue("dchi", VATDetail.dchi);
              setValue("ten", VATDetail.ten);
              setValue("sdthoai", VATDetail.sdthoai);
              setValue("dctdtu", VATDetail.dctdtu);
              setValue("send_mail", VATDetail.send_mail);
              setValue("stknhang", VATDetail.stknhang);
              setValue("tnhang", VATDetail.tnhang);
              setValue("fax", VATDetail.fax);
              setValue("website", VATDetail.website);
            }

            setControlFields({
              display: {
                ...initControlFields.display,
                user_profile_id: true,
                user_profile_phone: true,
                user_profile_name: true,
                user_profile_email: true,
                user_login: true,
                user_role: true,
              },
            });
            break;
          case userModeList.EDIT_USER_DETAIL:
            reset({ ...defaultValues, ...dataReset });
            if (VATDetail.usprofile) {
              setValue("mst", VATDetail.mst);
              setValue("dchi", VATDetail.dchi);
              setValue("ten", VATDetail.ten);
              setValue("sdthoai", VATDetail.sdthoai);
              setValue("dctdtu", VATDetail.dctdtu);
              setValue("send_mail", VATDetail.send_mail);
              setValue("stknhang", VATDetail.stknhang);
              setValue("tnhang", VATDetail.tnhang);
              setValue("fax", VATDetail.fax);
              setValue("website", VATDetail.website);
            }

            if (VATDetail.user_profile) {
              setDataUserProfile({
                value: VATDetail.user_profile.id,
                label: VATDetail.user_profile.code,
              });
            }

            setControlFields({
              display: {
                ...initControlFields.display,
                user_profile_id: true,
                user_profile_phone: true,
                user_profile_name: true,
                user_profile_email: true,
                user_login: true,
                user_role: true,
                btn_save: true,
              },
            });
            break;
          default:
            break;
        }
        setIsDetail(true);
      } else {
        if (Object.keys(dataDetail).length === 0) {
          setControlFields({
            display: {
              ...initControlFields.display,
              user_profile_id: true,
              user_profile_phone: true,
              user_profile_name: true,
              user_profile_email: true,
              user_login: true,
              user_role: true,
              btn_save: true,
            },
          });
          setValue("mst", "");
          setValue("dchi", "");
          setValue("ten", "");
          setValue("sdthoai", "");
          setValue("dctdtu", "");
          setValue("send_mail", "");
          setValue("stknhang", "");
          setValue("tnhang", "");
          setValue("fax", "");
          setValue("website", "");
        }
      }
    }
  }, [isDetail, isOpenModal, mode, reset, setValue, VATDetail, dataDetail]);

  // Action Dispatch
  useEffect(() => {
    if (isOpenModal) {
      if (userUpdate && userUpdate.success) {
        addToast(t("form.submit.update.user.success"), {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(
          listBusinessUnit({
            ...(userBusinessUnit && userBusinessUnit.params),
            page: 1,
            sizePerPage: 10,
          })
        );
        dispatch(resetUpdateBusinessUnit());
        toggleModal(mode);
      }
    }
  }, [addToast, dispatch, isOpenModal, mode, t, userUpdate]);

  // Error Dispatch
  useEffect(() => {
    if (isOpenModal) {
      if (errorDetail && errorDetail.message) {
        addToast(errorDetail.message, {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetDetailBusinessUnit());
      }

      if (errorUpdate) {
        if (errorUpdate.code && errorUpdate.code === 422) {
          addToast(
            "Đơn vị kinh doanh đã bị trùng, vui lòng thử lại đơn vị khác",
            {
              appearance: "error",
              autoDismiss: true,
            }
          );
        }
        if (
          errorUpdate &&
          errorUpdate.fields &&
          errorUpdate.fields.length > 0
        ) {
          errorUpdate.fields.map(item => {
            let fieldName = item.field;
            switch (item.field) {
              case "usprofile_id":
                fieldName = "user_profile_id";
                break;
              case "username":
                fieldName = "user_login";
                break;
              case "roles":
                fieldName = "user_role";
                break;
              case "common":
                addToast(item.message, {
                  appearance: "error",
                  autoDismiss: true,
                });
                break;
              default:
                break;
            }
            setError(fieldName, { type: "manual", message: item.message });
          });
        }
        dispatch(resetUpdateBusinessUnit());
        if (errorUpdate.code !== 422) {
          toggleModal(mode);
        }
      }
    }
  }, [
    addToast,
    dispatch,
    errorDetail,
    errorUpdate,
    isOpenModal,
    mode,
    setError,
    toggleModal,
  ]);

  const setDataUserProfile = data => {
    const userProfileId = data.value;
    const userProfile = employeeList.items.find(
      item => item.id === userProfileId
    );
    if (userProfile) {
      setValue("mst", userProfile.mst ? userProfile.mst : "");
      setValue("dchi", userProfile.dchi ? userProfile.dchi : "");
      setValue("ten", userProfile.ten ? userProfile.ten : "");
      setValue("sdthoai", userProfile.sdthoai ? userProfile.sdthoai : "");
      setValue("dctdtu", userProfile.dctdtu ? userProfile.dctdtu : "");
      setValue("send_mail", userProfile.send_mail ? userProfile.send_mail : "");
      setValue("stknhang", userProfile.stknhang ? userProfile.stknhang : "");
      setValue("tnhang", userProfile.tnhang ? userProfile.tnhang : "");
      setValue("fax", userProfile.fax ? userProfile.fax : "");
      setValue("website", userProfile.website ? userProfile.website : "");
    }
  };
  useEffect(() => {
    if (userCreate && userCreate.success) {
      addToast(t("form.submit.create.user.success"), {
        appearance: "success",
        autoDismiss: true,
      });
      dispatch(
        listBusinessUnit({
          ...(userBusinessUnit && userBusinessUnit.params),
          page: 1,
          sizePerPage: 10,
        })
      );
      dispatch(resetUpdateBusinessUnit());
      toggleModal(mode);
    }
  }, [addToast, dispatch, history, t, userCreate]);

  const onSubmit = values => {
    switch (mode) {
      case userModeList.EDIT_USER_DETAIL:
        if (Object.keys(dataDetail).length === 0) {
          dispatch(
            createBusinessUnit({
              mst: values.mst,
              dchi: values.dchi,
              ten: values.ten,
              sdthoai: values.sdthoai,
              dctdtu: values.dctdtu,
              send_mail: values.send_mail ? 1 : 0,
              stknhang: values.stknhang,
              tnhang: values.tnhang,
              fax: values.fax,
              website: values.website,
            })
          );
        } else {
          dispatch(
            updateBusinessUnit(VATDetail.id, {
              mst: values.mst,
              dchi: values.dchi,
              ten: values.ten,
              sdthoai: values.sdthoai,
              dctdtu: values.dctdtu,
              send_mail: values.send_mail ? 1 : 0,
              stknhang: values.stknhang,
              tnhang: values.tnhang,
              fax: values.fax,
              website: values.website,
            })
          );
        }

        break;
      default:
        break;
    }
  };

  return (
    <Modal
      size="lg"
      isOpen={isOpenModal}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={toggleModal}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggleModal}>
          {mode === userModeList.VIEW_USER_DETAIL && `${t("title.detail")}`}
          {mode === userModeList.EDIT_USER_DETAIL &&
          Object.keys(dataDetail).length === 0
            ? `${t("title.create")}`
            : controlFields.display.btn_save && `${t("title.edit")}`}
        </ModalHeader>
        {loadingDetail ? (
          <ModalBody>
            <LoadingFormNormal
              countInput="8"
              countButton="2"
              formClass="row-cols-1 row-cols-md-2"
              buttonClass="justify-content-end"
              buttonColClass="col-3"
            />
          </ModalBody>
        ) : (
          <React.Fragment>
            <ModalBody>
              <Form>
                <Row className="row-cols-1 row-cols-md-2">
                  {controlFields.display.user_profile_phone && (
                    <Col>
                      <FormGroup className="mb-3">
                        <Label htmlFor="mst">{t("table.mst")}</Label>
                        <input
                          disabled={mode === userModeList.VIEW_USER_DETAIL}
                          type="text"
                          className="form-control"
                          {...register("mst")}
                        />
                      </FormGroup>
                    </Col>
                  )}
                  {controlFields.display.user_profile_email && (
                    <Col>
                      <FormGroup className="mb-3">
                        <Label htmlFor="dchi">{t("table.dchi")}</Label>
                        <input
                          disabled={mode === userModeList.VIEW_USER_DETAIL}
                          type="text"
                          className="form-control"
                          {...register("dchi")}
                        />
                      </FormGroup>
                    </Col>
                  )}
                  {controlFields.display.user_profile_email && (
                    <Col>
                      <FormGroup className="mb-3">
                        <Label htmlFor="ten">{t("table.ten")}</Label>
                        <input
                          disabled={mode === userModeList.VIEW_USER_DETAIL}
                          type="text"
                          className="form-control"
                          {...register("ten")}
                        />
                      </FormGroup>
                    </Col>
                  )}
                  {controlFields.display.user_profile_email && (
                    <Col>
                      <FormGroup className="mb-3">
                        <Label htmlFor="sdthoai">{t("table.sdthoai")}</Label>
                        <input
                          disabled={mode === userModeList.VIEW_USER_DETAIL}
                          type="text"
                          className="form-control"
                          {...register("sdthoai")}
                        />
                      </FormGroup>
                    </Col>
                  )}

                  {controlFields.display.user_profile_email && (
                    <Col>
                      <FormGroup className="mb-3">
                        <Label htmlFor="dctdtu">{t("table.dctdtu")}</Label>
                        <input
                          disabled={mode === userModeList.VIEW_USER_DETAIL}
                          type="text"
                          className="form-control"
                          {...register("dctdtu")}
                        />
                        <br></br>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <input
                            type="checkbox"
                            disabled={mode === userModeList.VIEW_USER_DETAIL}
                            id="checkbox_sendmail"
                            className="custom-control-input checkbox-sendmail"
                            style={{
                              width: "20px",
                              height: "20px",
                              marginTop: 0,
                            }}
                            {...register("send_mail")}
                          />
                          <label
                            style={{ marginLeft: "10px", marginBottom: 0 }}
                            htmlFor="checkbox_sendmail"
                          >
                            Gửi thông tin đến thư điện tử này
                          </label>
                        </div>
                      </FormGroup>
                    </Col>
                  )}

                  {controlFields.display.user_profile_email && (
                    <Col>
                      <FormGroup className="mb-3">
                        <Label htmlFor="stknhang">{t("table.stknhang")}</Label>
                        <input
                          disabled={mode === userModeList.VIEW_USER_DETAIL}
                          type="text"
                          className="form-control"
                          {...register("stknhang")}
                        />
                      </FormGroup>
                    </Col>
                  )}
                  {controlFields.display.user_profile_email && (
                    <Col>
                      <FormGroup className="mb-3">
                        <Label htmlFor="tnhang">{t("table.tnhang")}</Label>
                        <input
                          disabled={mode === userModeList.VIEW_USER_DETAIL}
                          type="text"
                          className="form-control"
                          {...register("tnhang")}
                        />
                      </FormGroup>
                    </Col>
                  )}
                  {controlFields.display.user_profile_email && (
                    <Col>
                      <FormGroup className="mb-3">
                        <Label htmlFor="fax">{t("table.fax")}</Label>
                        <input
                          disabled={mode === userModeList.VIEW_USER_DETAIL}
                          type="text"
                          className="form-control"
                          {...register("fax")}
                        />
                      </FormGroup>
                    </Col>
                  )}
                  {controlFields.display.user_profile_email && (
                    <Col>
                      <FormGroup className="mb-3">
                        <Label htmlFor="website">{t("table.website")}</Label>
                        <input
                          disabled={mode === userModeList.VIEW_USER_DETAIL}
                          type="text"
                          className="form-control"
                          {...register("website")}
                        />
                      </FormGroup>
                    </Col>
                  )}
                </Row>
              </Form>
            </ModalBody>
            <ModalFooter>
              <Row className="justify-content-end">
                {controlFields.display.btn_save && (
                  <Col className="col-auto">
                    <Button
                      color="primary"
                      className="btn-label"
                      type="button"
                      onClick={() => {
                        handleSubmit(onSubmit)();
                      }}
                      disabled={loadingUpdate}
                    >
                      <i className="bx bx-save label-icon"></i>
                      {t("form.save")}
                    </Button>
                  </Col>
                )}
              </Row>
            </ModalFooter>
          </React.Fragment>
        )}
      </div>
    </Modal>
  );
};

DetailUser.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  dataDetail: PropTypes.object.isRequired,
  mode: PropTypes.string.isRequired,
  employeeList: PropTypes.object,
  userRoleList: PropTypes.object,
  userBusinessUnit: PropTypes.object,
};

DetailUser.defaultProps = {
  userBusinessUnit: {},
  isOpenModal: false,
  dataDetail: {},
  mode: "",
  employeeList: {},
  userRoleList: {},
};

export default DetailUser;
